import MapValidate from './MapValidate';

export default MapValidate;
